<template>
  <el-dialog title="维修记录"
             :visible.sync="showModal"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-col :span="24">
      <el-form :model="dealInfo"
               :rules="dealRules"
               ref="dealForm"
               label-width="130px"
               class="deal-form">
        <el-form-item label="维修状态："
                      prop="repair_status">
          <el-radio-group v-model="dealInfo.repair_status">
            <el-radio label="1">已维修</el-radio>
            <el-radio label="0">未维修</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="维修描述："
                      prop="repair_desc ">
          <el-input type="textarea"
                    v-model.trim="dealInfo.repair_desc "
                    placeholder="请输入维修描述"></el-input>
        </el-form-item>
        <el-form-item label="维修人："
                      prop="repairman">
          <el-input type="textarea"
                    v-model.trim="dealInfo.repairman"
                    placeholder="请输入维修人"></el-input>
        </el-form-item>
        <el-form-item label="维修人电话："
                      prop="rep_phone_no">
          <el-input type="textarea"
                    v-model.trim="dealInfo.rep_phone_no"
                    placeholder="请输入维修人电话"></el-input>
        </el-form-item>
        <el-form-item label="维修时间："
                      prop="repair_datetime">
          <el-date-picker v-model="dealInfo.repair_datetime"
                          :picker-options="pickerOptions"
                          type="date"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="选择维修时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/repair/repair'"
                 type="primary"
                 @click="handleConfirm('dealForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showModal: this.isShow,
      dealInfo: {
        repair_status: '1',
        repair_desc: '',
        repairman: '',
        rep_phone_no: '',
        repair_datetime: ''
      },
      dealRules: {
        repair_status: [{ required: true, message: '请选择是否完成' }]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  created() {
    this.dealInfo.repairman = localStorage.getItem('username')
    this.dealInfo.rep_phone_no = localStorage.getItem('mobile')
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getRoleInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.roleInfo.name = data.name
            this.roleInfo.remark = data.remark
            this.roleInfo.creator = localStorage.getItem('uId')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch
            .editRepair({ ...this.dealInfo, id: this.data.id })
            .then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    }
  }
}
</script>

<style></style>
